import { Scenario, CreateScenarioData } from '../types/auth';
import authService from './auth-service';
import { buildApiUrl } from '../config/api';

const API_BASE_URL = buildApiUrl('');

class ScenarioService {
  async getUserScenarios(): Promise<Scenario[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/`, {
        headers: authService.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch scenarios');
      }

      return await response.json();
    } catch (error) {
      console.error('Get user scenarios error:', error);
      throw error;
    }
  }

  async getPublicScenarios(): Promise<Scenario[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/public`);

      if (!response.ok) {
        throw new Error('Failed to fetch public scenarios');
      }

      return await response.json();
    } catch (error) {
      console.error('Get public scenarios error:', error);
      throw error;
    }
  }

  async getScenario(scenarioId: number): Promise<Scenario> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/${scenarioId}`, {
        headers: authService.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch scenario');
      }

      return await response.json();
    } catch (error) {
      console.error('Get scenario error:', error);
      throw error;
    }
  }

  async createScenario(scenarioData: CreateScenarioData): Promise<Scenario> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/`, {
        method: 'POST',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(scenarioData),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to create scenario');
      }

      return await response.json();
    } catch (error) {
      console.error('Create scenario error:', error);
      throw error;
    }
  }

  async updateScenario(scenarioId: number, scenarioData: Partial<CreateScenarioData>): Promise<Scenario> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/${scenarioId}`, {
        method: 'PUT',
        headers: authService.getAuthHeaders(),
        body: JSON.stringify(scenarioData),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to update scenario');
      }

      return await response.json();
    } catch (error) {
      console.error('Update scenario error:', error);
      throw error;
    }
  }

  async deleteScenario(scenarioId: number): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/scenarios/${scenarioId}`, {
        method: 'DELETE',
        headers: authService.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Failed to delete scenario');
      }
    } catch (error) {
      console.error('Delete scenario error:', error);
      throw error;
    }
  }
}

export const scenarioService = new ScenarioService();
export default scenarioService; 